import React from 'react';
import {connect} from 'react-redux';
import '../../../../CSS/chats.scss';
import {getTimeAgoString, preventDefaultDrag} from '../../../../Utils/utils';

class GroupChatListItem extends React.PureComponent {
    render() {
        const {chatData, lastMessageAt, translation, defaultTranslation} = this.props;
        const chat = chatData.chat;
        const timeAgoString = getTimeAgoString(lastMessageAt, this.props.languages.platformLanguage);
        const codedQuotationMark = '&#x27;';
        const videoCallMessage = `I${codedQuotationMark}ve set up a Video Meeting room. Please click here to join it.`;
        const renderLastMessage = chat.lastMessageText === videoCallMessage ? translation?.videoConferences.videoCallStarted || defaultTranslation?.videoConferences.videoCallStarted : chat.lastMessageText;
        return (
            <div
                color={chat._id === this.props.activeChatRoomId ? 'primary' : 'default'}
                className="group-chat-button"
                id={chat._id}
                onClick={this.props.handleOpenGroupChat(chat._id)}
            >
                <div onDragStart={preventDefaultDrag} className="avatar">
                    {chat.users.length ? (
                        <span>
                            {chat.users[0].first[0]}
                            {chat.users[0].last[0]}
                        </span>
                    ) : null}
                    {chatData.unread !== 0 ? (
                        <div
                            className={`online-button flex-center ${
                                chatData.unread.toString().length >= 3 ? 'fs9' : 'fs10'
                            }`}
                        >
                            <span>{chatData.unread.toString().length >= 3 ? '99+' : chatData.unread}</span>
                        </div>
                    ) : null}
                </div>
                <div onDragStart={preventDefaultDrag} className="chat-details">
                    {chat.name ? (
                        <p onDragStart={preventDefaultDrag} className="group-chat-name">
                            {chat.name}
                        </p>
                    ) : (
                        <div>
                            {chat.users.length ? (
                                <p onDragStart={preventDefaultDrag} className="group-chat-name">
                                    {chat.users.map((user, userIndex) => {
                                        return (
                                            <span onDragStart={preventDefaultDrag} draggable="false" key={user._id}>
                                                {user.first} {user.last}{userIndex !== (chat.users.length-1) ? ', ' : ''}
                                            </span>
                                        );
                                    })}
                                </p>
                            ) : null}
                        </div>
                    )}
                    {chat.users.length ? (
                        <span onDragStart={preventDefaultDrag} draggable="false" className="members-count">
                            {' '}
                            {chat.users.length}{' '}
                            {translation?.chatsDropdown.members || defaultTranslation?.chatsDropdown.members}
                        </span>
                    ) : null}
                    <p
                        dangerouslySetInnerHTML={{
                            __html: renderLastMessage,
                        }}
                        className={`last-message ${chatData.unread !== 0 ? 'bold' : ''}`}
                    />
                </div>
                <div>
                    <p onDragStart={preventDefaultDrag} className="time-ago">
                        {timeAgoString}
                    </p>
                </div>
                <div onDragStart={preventDefaultDrag} className="user-wrapper-separator" />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeChatRoomId: state.user.topNavigation.activeChatRoomId,
        languages: state.languages,
        translation: state.languages.translations[state.languages.platformLanguage],
        defaultTranslation: state.languages.translations['en'],
    };
};

export default connect(mapStateToProps)(GroupChatListItem);
